import { useEffect, useRef } from 'react';
import logTrailViewedAfterSignup from '@alltrails/amplitude/events/logTrailViewedAfterSignup';
import useUser from '@alltrails/context/hooks/useUser';

// The recently viewed trails feature relies on the "web page viewed" event add a trail to a user's recently viewed trails.
// This event is called on the initial page load but if a user is unauthenticated at that time, we cannot add the trail to their recently viewed trails.
// This hook fires a different amplitude event when a user signs in on the trail page which server also uses to track recently viewed trails.
const useTrailPageViewedTracking = (trailId: number) => {
  const user = useUser();

  const isUnauthenticatedOnPageLoad = useRef(!user);

  useEffect(() => {
    if (isUnauthenticatedOnPageLoad.current && user) {
      logTrailViewedAfterSignup({ trail_id: String(trailId) });
    }
  }, [trailId, user]);
};

export default useTrailPageViewedTracking;
